module.exports = __webpack_public_path__ + "img/pc-evol-vbet.345690ac.png";